import type { Ref } from 'vue';

import { computed } from 'vue';
import { useRoute } from 'vue-router';

import * as routeQueryHelpers from '@/helpers/routeQuery';

export interface DefRouteQuery {
  recipient?: number;
}
export interface RouteQueryComposable {
  recipient: Readonly<Ref<DefRouteQuery['recipient']>>;
}

export default function useSmsRouteQuery(
  defRouteQuery: DefRouteQuery,
): RouteQueryComposable {
  const _defRecipient = defRouteQuery.recipient;

  const route = useRoute();

  const recipient = computed<number | undefined>(() => {
    return routeQueryHelpers.getQueryNumberValue(
      route.query.recipient,
      _defRecipient,
    );
  });

  return {
    recipient,
  };
}
